export const buildPortString = (portName: string | null, portCode: string | null): string => {
  if (portName !== null && portCode !== null) {
    return `${portCode} (${portName})`;
  }
  return portName ?? portCode ?? "";
};
